module.exports = __webpack_public_path__ + "assets/svg/Icons/32/success-green-9d6674.svg";